const LOCAL_ORIGIN = "https://local.shortformnation.invalid";
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const CREATOR_ID_PATTERN = /^[A-Za-z0-9._-]{1,64}$/;

export interface ContentRewardJoinRedirectContext {
  joinAttemptId: string;
  rewardId: string;
  creatorId: string;
}

export function normalizeContentRewardJoinAttemptId(
  value: string | null | undefined
): string | null {
  const normalized = value?.trim() ?? "";
  return UUID_PATTERN.test(normalized) ? normalized.toLowerCase() : null;
}

/**
 * Extract telemetry context only from the exact same-origin Content Rewards
 * Discord return path. This parser never decides authorization or navigation.
 */
export function getContentRewardJoinRedirectContext(
  redirectTo: string | null | undefined
): ContentRewardJoinRedirectContext | null {
  if (!redirectTo || !redirectTo.startsWith("/") || redirectTo.startsWith("//")) {
    return null;
  }

  try {
    const url = new URL(redirectTo, LOCAL_ORIGIN);
    if (url.origin !== LOCAL_ORIGIN || url.searchParams.get("src") !== "discord") {
      return null;
    }

    const match = url.pathname.match(
      /^\/creator_studio\/content_rewards\/browse\/([^/]+)$/
    );
    if (!match) return null;

    const rewardId = decodeURIComponent(match[1]);
    const creatorId = url.searchParams.get("creator_id")?.trim() ?? "";
    const joinAttemptId = normalizeContentRewardJoinAttemptId(
      url.searchParams.get("join_attempt_id")
    );
    if (!rewardId || !CREATOR_ID_PATTERN.test(creatorId) || !joinAttemptId) {
      return null;
    }

    return { joinAttemptId, rewardId, creatorId };
  } catch {
    return null;
  }
}
